<template>
	<modal
		:min-width="modalOptions.largura"
		:min-height="modalOptions.altura"
		:exibir="exibir"
		:custom-actions="true"
		:titulo="tituloModal"
		@close="fecharModal"
		:acao-cancelar="fecharModal"
		classe-personalizada-body="padding-body"
		:is-confirmar-visivel="true"
	>
		<template #body>
			<az-container class="mt-0">
				<v-tabs
					v-model="abaSelecionada"
					class="v-tabs left-side"
					:fixed-tabs="!$vuetify.breakpoint.smAndUp"
					:dark="false"
					:vertical="!$vuetify.breakpoint.smAndUp"
					:hide-slider="false"
				>
					<template v-for="aba in abas">
						<v-tab
							active-class="tab-ativa"
							:key="aba.titulo"
							class="tab-header"
							append
							:disabled="!aba.isVisivel"
						>
							{{ aba.titulo }}
						</v-tab>
					</template>
				</v-tabs>

				<v-divider></v-divider>

		<v-tabs-items v-model="abaSelecionada">
					<v-tab-item :key="abas[0].titulo">
						<penalidade-aba-notificacoes
							:entidade-tipo="entidadeTipo"
							:id-ata="idAta"
							:id-entidade="idEntidade"
							:modo-visualizacao="isModoVisualizacao"
						></penalidade-aba-notificacoes>
					</v-tab-item>

					<v-tab-item :key="abas[1].titulo">
						<penalidade-aba-itens
							:entidade-tipo="entidadeTipo"
							:id-entidade="idEntidade"
							:textos-da-listagem-vazia="textosDaListagemVaziaItens"
							:modo-visualizacao="isModoVisualizacao"
						></penalidade-aba-itens>
					</v-tab-item>

					<v-tab-item :key="abas[2].titulo">
						<penalidade-aba-documentos
							:entidade-tipo="entidadeTipo"
							:id-ata="idAta"
							:id-entidade="idEntidade"
							:textos-da-listagem-vazia="textosDaListagemVaziaDocumentos"
							:modo-visualizacao="isModoVisualizacao"
						>
							<template #listagem-documentos>
								<slot name="listagem-documentos-entidade"></slot>
							</template>
						</penalidade-aba-documentos>
					</v-tab-item>

					<v-tab-item :key="abas[3].titulo">
						<penalidade-aba-sancao
							:entidade-tipo="entidadeTipo"
							:id-ata="idAta"
							:id-entidade="idEntidade"
							:modo-visualizacao="isModoVisualizacao"
							:is-visualizar="isVisualizar"
						></penalidade-aba-sancao>
					</v-tab-item>
				</v-tabs-items>
			</az-container>
		</template>

		<template #actions>
			<v-card-actions class="bg-white my-2 py-2">
				<botao-cancelar @cancelar="fecharModal"></botao-cancelar>
				<div class="ml-auto" v-if="!isVisualizar">
					<botao-primario
						@click="salvarInformacoes(true)"
						v-if="abaSelecionada === 3 && !isPenalidadeEfetivada"
						nome-botao="Efetivar"
						outlined
						class="mr-3"
					></botao-primario>
					<botao-primario
						@click="salvarInformacoes"
						v-if="exibirBotao"
						:nome-botao="nomeBotao"
					></botao-primario>
				</div>
			</v-card-actions>
		</template>
	</modal>
</template>

<script>
import Modal from '@/views/components/Modal'
import BotaoCancelar from '@/views/components/BotaoCancelar'
import BotaoPrimario from '@/views/components/BotaoPrimario'
import { mutationTypes } from '@/core/constants'
import { mapState } from 'vuex'
import PenalidadeAbaSancao from '@/views/components/penalidade/aba-sancao/PenalidadeAbaSancao'
import PenalidadeAbaItens from '@/views/components/penalidade/aba-itens/PenalidadeAbaItens'
import PenalidadeAbaNotificacoes from '@/views/components/penalidade/aba-notificacoes/PenalidadeAbaNotificacoes'
import PenalidadeAbaDocumentos from '@/views/components/penalidade/aba-documentos/PenalidadeAbaDocumentos'

export default {
	name: 'modal-penalidade',
	components: {
		PenalidadeAbaSancao,
		PenalidadeAbaDocumentos,
		PenalidadeAbaNotificacoes,
		PenalidadeAbaItens,
		BotaoPrimario,
		BotaoCancelar,
		Modal,
	},
	props: {
		exibir: {
			type: Boolean,
		},
		isVisualizar: {
			type: Boolean,
			default: false,
		},
		modalOptions: {
			type: Object,
			default: () => {
				return { largura: '50%', altura: '80%' }
			},
		},
		tituloModal: {
			type: String,
			default: () => 'Penalidade',
		},
		idEntidade: {
			type: [String, Number],
			required: true,
		},
		idAta: {
			type: [String, Number],
			required: true,
		},
		textosDaListagemVaziaDocumentos: {
			type: Object,
			default: () => {
				return { titulo: 'Nenhuma notificação por aqui' }
			},
		},
		textosDaListagemVaziaItens: {
			type: Object,
			default: () => {
				return { titulo: 'Nenhum item por aqui' }
			},
		},
		entidadeTipo: {
			type: Object,
			required: true,
		},
		penalidade: {
			type: Object,
			default: null,
		},
		notificacaoObrigatoria: {
			type: Boolean,
			required: true,
		},
	},
	emits: ['fechar-modal'],
	data() {
		return {
			acoesAoSalvar: {
				Notificacoes: () => this.$store.commit(mutationTypes.PENALIDADES.SET_INSERIR_NOTIFICACAO),
				Itens: () => this.$store.commit(mutationTypes.PENALIDADES.SET_SALVAR_ITENS),
				Sancao: (isEfetivar) =>
					this.$store.commit(mutationTypes.PENALIDADES.SET_SALVAR_EFETIVAR_SANCAO, isEfetivar),
			},
			exibirBotao: false,
		}
	},
	computed: {
		...mapState({
			abas: (state) => state.penalidades.abas,
			isPenalidadeEfetivada: (state) => state.penalidades.isPenalidadeEfetivada,
		}),
		abaSelecionada: {
			get() {
				return this.$store.state.penalidades.abaSelecionada
			},
			set(novoValor) {
				this.$store.commit(mutationTypes.PENALIDADES.SET_ABA_SELECIONADA, novoValor)
				this.verificarExibirBotao(novoValor)
			},
		},
		isModoVisualizacao() {
			return this.isPenalidadeEfetivada || this.isVisualizar
		},
		nomeBotao() {
			switch (this.abaSelecionada) {
				case 0:
					return 'Inserir notificação'
				case 1:
					return 'Confirmar'
				default:
					return 'Salvar'
			}
		},
	},
	watch: {
		isPenalidadeEfetivada() {
			this.verificarExibirBotao(this.abaSelecionada)
		},
		abaSelecionada() {
			this.verificarExibirBotao(this.abaSelecionada)
		},
	},
	mounted() {
		this.$store.commit(mutationTypes.PENALIDADES.SET_ID_PENALIDADE_SALVA, this.penalidade?.id)
		if (this.notificacaoObrigatoria && !this.penalidade) this.desabilitarOutrasAbas()
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.PENALIDADES.RESET_INFORMACOES)
	},
	methods: {
		salvarInformacoes(isEfetivarSancao) {
			const nomeAba = this.abas[this.abaSelecionada].nome
			this.acoesAoSalvar[nomeAba](isEfetivarSancao)
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		desabilitarOutrasAbas() {
			this.$store.commit(mutationTypes.PENALIDADES.SET_VISIBILIDADE_ABA, { aba: 3, habilitar: false })
		},
		verificarExibirBotao(abaSelecionada) {
			if (this.isPenalidadeEfetivada) {
				this.exibirBotao = abaSelecionada === 3
				return
			}

			this.exibirBotao = abaSelecionada !== 2
		},
	},
}
</script>

<style lang="stylus"></style>
